module.exports = {
  "/": {
    "name": "storefront-all-categories",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/featured": {
    "name": "storefront-featured-apps",
    "success": {
      "storefront page loaded": [
        "FEATURED_APPS_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/page/:page": {
    "name": "storefront-all-categories-page",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/:superCategoryOrSlug": {
    "name": "storefront-super-category-or-detail",
    "success": {
      "detail not found error state": [
        "DETAIL_NOT_FOUND_ERROR_LOAD"
      ],
      "detail page loaded": [
        "DETAIL_HEADER_LOAD"
      ],
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/_detail/:slug": {
    "name": "detail-shortlink",
    "success": {
      "detail not found error state": [
        "DETAIL_NOT_FOUND_ERROR_LOAD"
      ],
      "detail page loaded": [
        "DETAIL_HEADER_LOAD"
      ]
    },
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/:superCategory/page/:page": {
    "name": "storefront-super-category-page",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/:slug/write-review": {
    "name": "detail-write-review",
    "success": {
      "detail not found error state": [
        "DETAIL_NOT_FOUND_ERROR_LOAD"
      ],
      "detail review page loaded": [
        "REVIEW_WIZARD_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/:slug/reviews": {
    "name": "detail-reviews",
    "success": {
      "detail reviews loaded": [
        "DETAIL_REVIEWS_LOAD"
      ]
    }
  },
  "/:superCategory/:category": {
    "name": "storefront-category",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/:superCategory/:category/page/:page": {
    "name": "storefront-category-page",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/:superCategory/:category/:slug/write-review": {
    "name": "detail-write-review-legacy",
    "success": {
      "detail not found error state": [
        "DETAIL_NOT_FOUND_ERROR_LOAD"
      ],
      "detail review page loaded": [
        "REVIEW_WIZARD_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/:superCategory/:category/:slug/reviews": {
    "name": "detail-reviews-legacy",
    "success": {
      "detail reviews loaded": [
        "DETAIL_REVIEWS_LOAD"
      ]
    }
  },
  "/:superCategory/:category/:slug": {
    "name": "detail-legacy",
    "success": {
      "detail not found error state": [
        "DETAIL_NOT_FOUND_ERROR_LOAD"
      ],
      "detail page loaded": [
        "DETAIL_HEADER_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  }
};